var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 31.999H-.001V10.625h6.875Zm-3.2-24.625h-.05A3.53 3.53 0 0 1-.001 3.688 3.55 3.55 0 0 1 3.713-.001a3.54 3.54 0 0 1 3.675 3.688 3.55 3.55 0 0 1-3.713 3.688Zm28.324 24.625h-6.874V20.313c0-2.8-1-4.712-3.488-4.712a3.76 3.76 0 0 0-3.525 2.537 4.6 4.6 0 0 0-.238 1.688v12.173h-6.875V10.625h6.875v2.974a6.96 6.96 0 0 1 6.2-3.475c4.513 0 7.925 2.975 7.925 9.387z"
  })));
};
export default SvgLinkedin;